import { UUID } from "@opendaw/lib-std";
export var ScriptPaths;
(function (ScriptPaths) {
    ScriptPaths.Folder = "scripts/v1";
    ScriptPaths.TrashFile = `${ScriptPaths.Folder}/trash.json`;
    ScriptPaths.ScriptFile = "script.ts";
    ScriptPaths.ScriptMetaFile = "meta.json";
    ScriptPaths.scriptFile = (uuid) => `${ScriptPaths.scriptFolder(uuid)}/${ScriptPaths.ScriptFile}`;
    ScriptPaths.scriptMeta = (uuid) => `${ScriptPaths.scriptFolder(uuid)}/${ScriptPaths.ScriptMetaFile}`;
    ScriptPaths.scriptFolder = (uuid) => `${ScriptPaths.Folder}/${UUID.toString(uuid)}`;
})(ScriptPaths || (ScriptPaths = {}));
